export function init() {
	
	// Overlay closes things -------------------------------------------------------------------------- //

	if (document.querySelector('.overlay')) {
		document.querySelector('.overlay').addEventListener('click', (e) => {
			e.preventDefault();
			document.querySelector('.wizard').classList.remove('-visible');
			document.querySelector('.overlay').classList.remove('-visible');
			if (document.querySelector('.key-features-modal')) {
				document.querySelector('.key-features-modal').classList.remove('-visible');
			}
			if (document.querySelector('.reusable-modal')) {
				const allReusableModals = document.querySelectorAll('.reusable-modal');
				allReusableModals.forEach((el) => {
					el.classList.remove('-visible');
				});
			}
		});
	}

	// Toggle key features modal ---------------------------------------------------------------------- //

	const toggleKeyFeatures = () => {
		document.querySelector('.key-features-modal').classList.toggle('-visible');
		document.querySelector('.overlay').classList.toggle('-visible');
	}

	if (document.querySelector('.toggle-key-features')) {
		document.querySelector('.toggle-key-features').addEventListener('click', (e) => {
			e.preventDefault();
			toggleKeyFeatures();
		});

		document.querySelector('.key-features-modal .close-modal').addEventListener('click', (e) => {
			e.preventDefault();
			toggleKeyFeatures();
		});
	}

	// Toggle reusable module modal ------------------------------------------------------------------- //

	const toggleReusableModal = (id) => {
		document.querySelector('.reusable-modal[data-id="' + id + '"]').classList.toggle('-visible');
		document.querySelector('.overlay').classList.toggle('-visible');
	}

	if (document.querySelector('.promo .openmodal')) {

		const allButtons = document.querySelectorAll('.promo .openmodal');
		allButtons.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				toggleReusableModal(e.target.dataset.modalid);
			});
		})

		const allCloseButtons = document.querySelectorAll('.reusable-modal .close-modal');
		allCloseButtons.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				toggleReusableModal(e.target.dataset.modalid);
			});
		});
	}

}